import { render, staticRenderFns } from "./cardDetails.vue?vue&type=template&id=4da018c2&scoped=true"
import script from "./cardDetails.vue?vue&type=script&lang=js"
export * from "./cardDetails.vue?vue&type=script&lang=js"
import style0 from "./cardDetails.vue?vue&type=style&index=0&id=4da018c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da018c2",
  null
  
)

export default component.exports